<div class="box">
  <h1 style="font-size: xxx-large; margin-top: 5rem">404</h1>

  <img width="250" src="assets/pagenotfound.png" />

  <h2>Not even we could decrypt this request.</h2>

  <button
    mat-raised-button
    color="primary"
    class="example-full-width"
    [routerLink]="['/']"
    style="width: 15vw"
  >
    Go back
  </button>
</div>
